module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-hotspots-8e242c6fb0474452b3526f0c2a2ad0d5.png";